import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faCheck,
    faCheckSquare,
    faCheckCircle,
    faChevronDown,
    faChevronRight,
    faChevronUp,
    faDownload,
    faExclamationTriangle,
    faFileArchive,
    faFileDownload,
    faInfo,
    faInfoSquare,
    faQuestion,
    faSirenOn,
    faSpinnerThird,
    faDatabase,
    faPrint,
    faClipboardList,
    faTimesCircle,
    faSave,
    faTrash,
    faPencil,
    faLayerGroup,
    faColumns,
    faFolders,
    faList,
    faFile,
    faEye,
    faEyeSlash,
} from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faCheck,
    faCheckSquare,
    faCheckCircle,
    faChevronDown,
    faChevronRight,
    faChevronUp,
    faDownload,
    faExclamationTriangle,
    faFileArchive,
    faFileDownload,
    faInfo,
    faInfoSquare,
    faQuestion,
    faSirenOn,
    faSpinnerThird,
    faDatabase,
    faPrint,
    faClipboardList,
    faTimesCircle,
    faSave,
    faTrash,
    faPencil,
    faLayerGroup,
    faColumns,
    faFolders,
    faList,
    faFile,
    faEye,
    faEyeSlash,
)

export default FontAwesomeIcon
